import Select from './Select.view';

export default Select;
